import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BadgeColor = {
    slate: ['text-slate-500', 'dark:text-slate-400', 'bg-slate-100', 'dark:bg-slate-700'],
    yellow: ['text-yellow-900', 'dark:text-yellow-300', 'bg-yellow-500', 'dark:bg-yellow-700'],
    emerald: ['text-emerald-600', 'dark:text-emerald-400', 'bg-emerald-100', 'dark:bg-emerald-400/30'],
    green: ['text-slate-800', 'dark:text-slate-800', 'bg-green-300', 'dark:bg-green-500'],
    rose: ['text-rose-500', 'dark:text-rose-400', 'bg-rose-100', 'dark:bg-rose-500/30'],
    blue: ['text-blue-500', 'dark:text-blue-400', 'bg-blue-100', 'dark:bg-blue-500/30'],
    violet: ['text-violet-600', 'dark:text-violet-300', 'bg-violet-100', 'dark:bg-violet-500/30'],
};

const BadgeClasses = [
    'inline-flex items-center font-medium rounded-full text-center px-2 py-0.5'
];

function Badge({ color, children, className = '', icon = null, textSize = 'xs' }) {
    const textSizeClass = textSize ? 'text-' + textSize : 'text-xs';
    let classes = [...(BadgeColor[color ?? 'slate'] ?? BadgeColor['slate']), textSizeClass, ...BadgeClasses];

    return (
        <div className={`${classes.join(' ')} ${className}`}>
            {icon && <FontAwesomeIcon icon={icon} />}
            {children}
        </div>
    );
}

export default Badge;
